export default "__VITE_ASSET__qrppr5Ec__"